export default __webpack_public_path__ + "media/images/corbeille-595d73b718f504d587ab9813a1e896b9.png";